/** @jsx jsx */
import { CCallout, CModal } from "@coreui/react"
import { jsx } from "@emotion/react"
import Close from "assets/icons/modalClose.svg"
import PropTypes from "prop-types"

export default function ModalWithCross({
  show,
  setShow,
  message,
  sizeOfModal
}) {

  return (
    <CModal
      show={show}
      onClose={() => setShow(false)}
      size={sizeOfModal}
      centered
    >
      <CCallout color="warning" className="m-0 py-3">
        <div
          className="d-flex justify-content-end cursor-pointer"
          onClick={() => setShow(false)}
        >
          <img src={Close} alt="close-icon" className="h-100" />
        </div>

        {message}
      </CCallout>
    </CModal>
  )
}

ModalWithCross.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sizeOfModal: PropTypes.string
}
